import { Component, HostListener, OnInit } from '@angular/core';
import { BreakingLiveService } from 'src/app/core/services/breaking-live.service';
import { BreakingLive, BrakingLiveRequest } from 'src/app/models/breaking-live';

@Component({
  selector: 'app-breaking-live',
  templateUrl: './breaking-live.component.html',
  styleUrls: ['./breaking-live.component.css']
})
export class BreakingLiveComponent implements OnInit {

  latestStatus: boolean = true;            // true = En Vivo, false = Última Hora
  articleUrl: string = '';                 // URL ingresada por el usuario
  articleTitle: string = '';               // Título extraído del artículo
  isLoading: boolean = false;              // Para bloquear durante solicitudes
  showBanner: boolean = false;             // Mostrar u ocultar barra preview
  estadoInicial: BreakingLive;
  showSuccessModal: boolean = false;
  showDeleteModal: boolean = false;


  constructor(private breakingLiveService: BreakingLiveService) { }

  ngOnInit(): void {
    this.cargarEstadoInicial();
  }

  async cargarEstadoInicial() {
    try {
      this.estadoInicial = await this.breakingLiveService.getCurrentStatus();
      if (this.estadoInicial.alerta !== 'apagado' && this.estadoInicial.articulo?.url) {
        this.articleUrl = this.estadoInicial.articulo.url;
        this.articleTitle = this.estadoInicial.articulo.titulo;
        this.latestStatus = this.estadoInicial.alerta === 'en_vivo';
        this.showBanner = true;
      }
    } catch (err) {
      console.error('Error al cargar estado inicial:', err);
    }
  }

  getAlert() {
    return this.latestStatus ? 'en_vivo' : 'ultima_hora';
  }

  async activarAlerta() {
    if (!this.articleUrl) return;
    this.isLoading = true;
    try {
      // Enviar alerta al backend
      const alerta = this.getAlert();
      const payload: BrakingLiveRequest = {
        alerta: alerta,
        url: this.articleUrl
      };
      this.breakingLiveService.saveAlarm(payload).subscribe(() => {
        this.showBanner = true;
        this.isLoading = false;
        this.cargarEstadoInicial();
        this.showSuccessModal = true;
      }, () => {
        console.error('Error al guardar alerta');
        this.isLoading = false;
      });
    } catch (error) {
      console.error('Error activando alerta:', error);
      this.isLoading = false;
    }
  }

  cerrarModalExito() {
    this.showSuccessModal = false;
  }  

  changeAlert(event: any) {
    const alerta = this.getAlert();

    if (alerta == this.estadoInicial.alerta && this.estadoInicial.articulo.url != "") {
      this.articleUrl = this.estadoInicial.articulo.url;
      this.articleTitle = this.estadoInicial.articulo.titulo;
      this.showBanner = true;
    } else {
      this.articleUrl = '';
      this.articleTitle = '';
      this.showBanner = false;
    }
  }

  confirmarEliminar() {
    this.showDeleteModal = true;
  }
  
  borrarAlertaConfirmada() {
    this.articleUrl = '';
    this.articleTitle = '';
    this.showBanner = false;
    this.showDeleteModal = false;
  
    const payload: BrakingLiveRequest = {
      alerta: 'apagar',
      url: ""
    };
  
    this.breakingLiveService.saveAlarm(payload).subscribe(() => {
      console.log('Alerta apagada correctamente');

      this.cargarEstadoInicial();
    });
  }
  

  @HostListener('document:keydown.enter', ['$event'])
  onEnter(event: KeyboardEvent) {
    if (this.articleUrl) {
      this.activarAlerta();
    }
  }
}